// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"b409b6b0a11c855f8463","966":"9257751f207a7db4a8f4"}[chunkId] + ".js";
};